var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockHint = function SvgUnlockHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.468 15.603-.69 4.685zm1.018.009.831 4.595zM15.732 12.49l4.67.793zm.031-1.068 4.613-.68zM12.615 8.33l.751-4.676Zm-1.023-.018-.766-4.61ZM8.45 11.697l-4.768-.75Zm-.038 1.044-4.57.797z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.494
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.517
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.669 3.545A5.105 5.455 2.552 0 1 20.7 8.556M6.706 7.852a4.18 5.371-67.343 0 1 .74-.85M8.744 20.574a5.105 5.455 5.277 0 1-3.807-1.377 5.105 5.455 5.277 0 1-1.65-3.909"
  })));
};
export default SvgUnlockHint;